export default __webpack_public_path__ + "static/media/a008-3.91c1153c.svg";